import { render, staticRenderFns } from "./Statistique.vue?vue&type=template&id=b67dc37a&scoped=true&"
import script from "./Statistique.vue?vue&type=script&lang=js&"
export * from "./Statistique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67dc37a",
  null
  
)

export default component.exports